import type { PageSection } from 'Types/pageSection';

import { AdditionalInfoSection } from './sections/AdditionalInfoSection/AdditionalInfoSection';
import { ConditionAndDamageSection } from './sections/ConditionAndDamageSection/ConditionAndDamageSection';
import { EarlyDocumentsSection, SectionBadge } from './sections/EarlyDocumentsSection';
import { ExLeaseSection } from './sections/ExLeaseSection/ExLeaseSection';
import { LocationSection } from './sections/LocationSection/LocationSection';
import { MechanicalAndElectricalIssuesSection } from './sections/MechanicalAndElectricalIssuesSection';
import { MobilizeExteriorDamageSection } from './sections/MobilizeExteriorDamageSection/MobilizeExteriorDamageSection';
import { MobilizeInteriorDamageSection } from './sections/MobilizeInteriorDamageSection/MobilizeInteriorDamageSection';
import { MobilizeSection } from './sections/MobilizeSection/MobilizeSection';
import { MobilizeTyreDamageSection } from './sections/MobilizeTyreDamageSection/MobilizeTyreDamageSection';
import { MobilizeWheelDamageSection } from './sections/MobilizeWheelDamageSection/MobilizeWheelDamageSection';
import { MotSection } from './sections/MotSection';
import { RelistDetailsSection } from './sections/RelistDetailsSection/RelistDetailsSection';
import { ServiceHistoryEnhancedSection } from './sections/ServiceHistoryEnhancedSection/ServiceHistoryEnhancedSection';
import { ServiceHistoryFeedback } from './sections/ServiceHistoryEnhancedSection/ServiceHistoryFeedback';
import { SpecificationSection } from './sections/SpecificationSection';
import { TradeSellerDetailsSection } from './sections/TradeSellerDetailsSection/TradeSellerDetailsSection';
import { VehicleDetailsSection } from './sections/VehicleDetailsSection/VehicleDetailsSection';
import { VehicleFeaturesSection } from './sections/VehicleFeaturesSection/VehicleFeaturesSection';
import { WheelsAndTyresSection } from './sections/WheelsAndTyresSection/WheelsAndTyresSection';

import styles from './VehicleDetailsRedesign.module.scss';

export const SECTIONS = [
	{
		id: 'summary',
		label: 'Summary',
	},
	{
		component: () => <RelistDetailsSection />,
		id: 'relistDetails',
		label: 'Relist details',
	},
	{
		action: () => <SectionBadge />,
		component: () => <EarlyDocumentsSection />,
		id: 'earlyDocuments',
		label: 'Seller documents',
	},
	{
		component: () => <TradeSellerDetailsSection />,
		id: 'tradeSellerDetails',
		label: 'Trade seller details',
	},
	{
		className: styles.mobilizeCard,
		component: () => <MobilizeSection />,
		id: 'mobilize',
		label: 'Mobilize on Motorway',
		title: (
			<>
				<span className={styles.mobilizeHighlight}>Mobilize</span> on Motorway
			</>
		),
	},
	{
		className: styles.mobilizeCard,
		component: () => <ExLeaseSection />,
		id: 'exLease',
		label: 'Mobilize on Motorway',
		title: (
			<>
				<span className={styles.mobilizeHighlight}>Mobilize</span> on Motorway
			</>
		),
	},
	{
		component: () => <LocationSection />,
		id: 'location',
		label: 'Location',
	},
	{
		component: () => <VehicleFeaturesSection />,
		id: 'features',
		label: 'Features',
	},
	{
		component: () => <SpecificationSection />,
		id: 'specification',
		label: 'Specification',
	},
	{
		component: () => <VehicleDetailsSection />,
		id: 'vehicleDetails',
		label: 'Vehicle details',
	},
	{
		component: () => <MotSection />,
		id: 'motHistory',
		label: 'MOT history',
	},
	{
		action: () => <ServiceHistoryFeedback />,
		component: () => <ServiceHistoryEnhancedSection />,
		id: 'serviceHistory',
		label: 'Service history',
	},
	{
		component: () => <MechanicalAndElectricalIssuesSection />,
		id: 'mechanicalAndElectrical',
		label: 'Mechanical & electrical',
	},
	{
		component: () => <ConditionAndDamageSection />,
		id: 'conditionAndDamage',
		label: 'Condition & damage',
	},
	{
		component: () => <MobilizeExteriorDamageSection />,
		id: 'mobilizeExteriorDamage',
		label: 'Exterior damage',
	},
	{
		component: () => <MobilizeInteriorDamageSection />,
		id: 'mobilizeInteriorDamage',
		label: 'Interior damage',
	},
	{
		component: () => <MobilizeWheelDamageSection />,
		id: 'mobilizeWheelDamage',
		label: 'Wheel damage',
	},
	{
		component: () => <MobilizeTyreDamageSection />,
		id: 'mobilizeTyreDamage',
		label: 'Tyre damage',
	},
	{
		component: () => <WheelsAndTyresSection />,
		id: 'wheelsAndTyres',
		label: 'Wheels & tyres',
	},
	{
		component: () => <AdditionalInfoSection />,
		id: 'additionalInfo',
		label: 'Additional information',
	},
] satisfies PageSection[];

export const GAP_SIZE = 32;

export const SIMILAR_CONTAINER_MIN_HEIGHT = 400;
